export { default } from "./use-application-insights";
